export default class Paths {
  public static currentHostname = window.location.hostname
  public static apiV1BaseUrl = '/api/v1'
  public static apiV2BaseUrl = '/api/v2'
  public static webSocketBaseUrl = `ws://${Paths.currentHostname}:15674`

  public static authBaseUrl = `${Paths.apiV1BaseUrl}/auth`
  public static registrationsRoot = `${Paths.apiV1BaseUrl}/registration`
  public static assistanceBaseUrl = `${Paths.apiV1BaseUrl}/assistances`
  public static assistanceCategoryBaseUrl = `${Paths.apiV1BaseUrl}/assistanceCategories`
  public static integrationsBaseUrl = `${Paths.apiV1BaseUrl}/integrations`
  public static mobilityCategoryBaseUrl = `${Paths.apiV1BaseUrl}/mobilityCategories`
  public static mobilityBaseUrl = `${Paths.apiV1BaseUrl}/mobilities`
  public static paymentBaseUrl = `${Paths.apiV1BaseUrl}/payment`
  public static subscriptionBaseUrl = `${Paths.apiV1BaseUrl}/subscriptions`
  public static providerBaseUrl = `${Paths.apiV1BaseUrl}/providers`
  public static providerProductBaseUrl = `${Paths.apiV1BaseUrl}/providersProducts`
  public static providerServiceLevelBaseUrl = `${Paths.apiV1BaseUrl}/providersServicesLevels`
  public static riderBaseUrl = `${Paths.apiV1BaseUrl}/riders`
  public static riderLocationBaseUrl = `${Paths.apiV1BaseUrl}/riderLocation`
  public static servicePricingBaseUrl = `${Paths.apiV1BaseUrl}/servicePricings`
  public static servicePaymentMethodsBaseUrl = `${Paths.apiV1BaseUrl}/paymentMethods`
  public static organizationTeamMemberBaseUrl = `${Paths.apiV1BaseUrl}/organizationTeamMembers`
  public static stationUserBaseUrl = `${Paths.apiV1BaseUrl}/stationUsers`
  public static importTemplateBaseUrl = `${Paths.apiV1BaseUrl}/importTemplate`
  public static serviceProgramBaseUrl = `${Paths.apiV1BaseUrl}/servicePrograms`
  public static serviceDaysHoursBaseUrl = `${Paths.apiV1BaseUrl}/serviceDaysHours`
  public static driverBaseUrl = `${Paths.apiV1BaseUrl}/operators`
  public static driverV2BaseUrl = `${Paths.apiV2BaseUrl}/operators`
  public static serviceMembershipBaseUrl = `${Paths.apiV1BaseUrl}/memberships`
  public static tripsBaseUrl = `${Paths.apiV1BaseUrl}/trips`
  public static tripsV2BaseUrl = `${Paths.apiV2BaseUrl}/trips`
  public static tripsFeedbackBaseUrl = `${Paths.apiV1BaseUrl}/trip-feedbacks`
  public static mobileTripsBaseUrl = `${Paths.apiV1BaseUrl}/mobile/trips`
  public static userBaseUrl = `${Paths.apiV1BaseUrl}/user`
  public static vehicleBaseUrl = `${Paths.apiV1BaseUrl}/vehicles`
  public static vehicleColorBaseUrl = `${Paths.apiV1BaseUrl}/vehicleColors`
  public static vehicleMakeBaseUrl = `${Paths.apiV1BaseUrl}/vehicleMakes`
  public static vehicleModelBaseUrl = `${Paths.apiV1BaseUrl}/vehicleModels`
  public static vehicleTypeBaseUrl = `${Paths.apiV1BaseUrl}/vehicleTypes`
  public static vehicleAccommodationBaseUrl = `${Paths.apiV1BaseUrl}/vehicleAccommodations`
  public static pingBaseUrl = `${Paths.apiV1BaseUrl}/ping`
  public static dispatchBaseUrl = `${Paths.apiV1BaseUrl}/dispatch`
  public static geolocationServiceBaseUrl = `${Paths.apiV1BaseUrl}/geolocation`
  public static waypointServiceBaseUrl = `${Paths.apiV1BaseUrl}/waypoints`
  public static zoneServiceBaseUrl = `${Paths.apiV1BaseUrl}/zones`
  public static serviceBaseUrl = `${Paths.apiV1BaseUrl}/services`
  public static teamMemberPermissionBaseUrl = `${Paths.apiV1BaseUrl}/teamMemberPermission`
  public static importBaseUrl = `${Paths.apiV1BaseUrl}/import`
  public static groupRidesBaseUrl = `${Paths.apiV1BaseUrl}/group_rides`
  public static serviceDesignatedZoneBaseUrl = `${Paths.apiV1BaseUrl}/designatedZone`
  public static routeOptimization = `${Paths.apiV1BaseUrl}/route_optimization`
  public static optimizeTrips = `${Paths.apiV1BaseUrl}/optimize_trips`
  public static temporaryVehicles = `${Paths.apiV1BaseUrl}/temporary_vehicles`
  public static temporaryVehiclesTripsCount = `${Paths.tripsBaseUrl}/temporary_vehicles/services`
  public static operatorSchedule = `${Paths.driverBaseUrl}/schedules/active/getAllOperatorSchedule`

  public static assistanceCategory = class {
    public static base = Paths.assistanceCategoryBaseUrl
    public static getAll = `${Paths.assistanceCategoryBaseUrl}/doGetAll`
    public static getAllWithAssistances = `${Paths.assistanceCategoryBaseUrl}/doGetAllAssistances`
    public static getOneWithAssistancesById = `${Paths.assistanceCategoryBaseUrl}/doGetOneAssistances`
  }

  public static assistance = class {
    public static base = Paths.assistanceBaseUrl
    public static create = `${Paths.assistanceBaseUrl}`
    public static getAll = `${Paths.assistanceBaseUrl}/doGetAll`
    public static remove = `${Paths.assistanceBaseUrl}`
  }

  public static integrations = class {
    public static base = Paths.integrationsBaseUrl
  }

  public static mobility = class {
    public static base = Paths.mobilityBaseUrl
    public static create = `${Paths.mobilityBaseUrl}`
    public static getAll = `${Paths.mobilityBaseUrl}/doGetAll`
    public static remove = `${Paths.mobilityBaseUrl}`
  }

  public static mobilityCategory = class {
    public static base = Paths.mobilityCategoryBaseUrl
    public static getAll = `${Paths.mobilityCategoryBaseUrl}/doGetAll`
    public static getAllWithMobilities = `${Paths.mobilityCategoryBaseUrl}/doGetAllMobilities`
    public static getOneWithMobilitiesById = `${Paths.mobilityCategoryBaseUrl}/doGetOneMobilities`
  }

  public static payment = class {
    public static tripReceipts = `${Paths.paymentBaseUrl}/receipts/trip`
    public static riderTripReceipts = `${Paths.paymentBaseUrl}/receipts/rider`
    public static addPaymentSource = `${Paths.paymentBaseUrl}/doAddPaymentSource`
    public static updateDefaultPaymentSource = `${Paths.paymentBaseUrl}/wallets/updateDefaultPaymentSource`
    public static removePaymentSource = `${Paths.paymentBaseUrl}/doRemovePaymentSource`
    public static riderWallet = `${Paths.paymentBaseUrl}/wallets`
    public static riderAutochargeConfig = `${Paths.paymentBaseUrl}/autocharge_configs`
    public static riderWalletTransactions = `${Paths.paymentBaseUrl}/wallet_transactions`
    public static riderWalletTransactionHistory = `${Paths.paymentBaseUrl}/wallet_transactions/full_history`
    public static depositBalance = `${Paths.paymentBaseUrl}/wallet_transactions/deposit_balance`
    public static depositBonusBalance = `${Paths.paymentBaseUrl}/wallet_transactions/deposit_bonus_balance`
    public static refundPayment = `${Paths.paymentBaseUrl}/wallet_transactions/refund`
    public static refundedPayment = `${Paths.paymentBaseUrl}/refund/amount`
    public static rechargeWallet = `${Paths.paymentBaseUrl}/wallet_transactions/recharge`
  }

  public static provider = class {
    public static base = Paths.providerBaseUrl
    public static getAllWithActiveProducts = `${Paths.providerBaseUrl}/doGetAllWithActiveProducts`
    public static getManyWithDeactivatedProducts = `${Paths.providerBaseUrl}/doGetManyWithDeactivatedProducts`
    public static getOneWithProductsById = `${Paths.providerBaseUrl}/doGetOneWithProductsById`
  }

  public static providerProduct = class {
    public static base = Paths.providerProductBaseUrl
    public static findAvailable = `${Paths.providerProductBaseUrl}/findAvailable`
    public static getOneWithPricingById = `${Paths.providerProductBaseUrl}/doGetOneWithPricingById/:id`
    public static getManyByOrganizationId = `${Paths.providerProductBaseUrl}/doGetByOrganizationId`
    public static calculateOnePricing = `${Paths.providerProductBaseUrl}/doCalculateOnePricing`
    public static activate = `${Paths.providerProductBaseUrl}/doActivate`
    public static deactivate = `${Paths.providerProductBaseUrl}/doDeactivate`
  }

  public static providerServiceLevel = class {
    public static base = Paths.providerServiceLevelBaseUrl
  }

  public static rider = class {
    public static base = Paths.riderBaseUrl
    public static availableProducts = `${Paths.riderBaseUrl}/:riderId/availableProducts`
    public static integrationProduct = `${Paths.riderBaseUrl}/:riderId/integrationProduct`
    public static findByFullNameOrPhoneNumber = `${Paths.riderBaseUrl}/doFindByFullNameOrPhoneNumber`
    public static getManyByOrganizationId = `${Paths.riderBaseUrl}/doGetManyByOrganizationId`
    public static getOneWithAssistances = `${Paths.riderBaseUrl}/doGetOneWithAssistances`
    public static getOneWithLocations = `${Paths.riderBaseUrl}/doGetOneWithLocations`
    public static getOneWithLocationActivities = `${Paths.riderBaseUrl}/locationActivities`
    public static getOneWithMemberships = `${Paths.riderBaseUrl}/doGetOneWithMemberships`
    public static getOneWithMobilities = `${Paths.riderBaseUrl}/doGetOneWithMobilities`
    public static getOneWithPersonalInfo = `${Paths.riderBaseUrl}/doGetOneWithPersonalInfo`
    public static getOneWithMobilitiesAndPersonalInfoById = `${
      Paths.riderBaseUrl
    }/doGetOneWithMobilitiesAndPersonalInfoById`
    public static getOneByUsername = `${Paths.riderBaseUrl}/doGetOneByUsername`
    public static activate = `${Paths.riderBaseUrl}/doActivate`
    public static updateArchiveStatus = `${Paths.riderBaseUrl}/doUpdateArchiveStatus`
    public static deactivate = `${Paths.riderBaseUrl}/doDeactivate`
    public static updateOneWithAssistances = `${Paths.riderBaseUrl}/doUpdateOneWithAssistances`
    public static updateOneWithLocation = `${Paths.riderBaseUrl}/doUpdateOneWithLocation`
    public static updateOneWithLocations = `${Paths.riderBaseUrl}/doUpdateOneWithLocations`
    public static updateOneWithMemberships = `${Paths.riderBaseUrl}/doUpdateOneWithMemberships`
    public static updateOneWithMobilities = `${Paths.riderBaseUrl}/doUpdateOneWithMobilities`
    public static updateOneWithPersonalInfo = `${Paths.riderBaseUrl}/doUpdateOneWithPersonalInfo`
    public static getRiderChangeLog = `${Paths.riderBaseUrl}/changeLog`
    public static updateRiderServiceMemberships = `${Paths.serviceMembershipBaseUrl}/updateRiderServiceMemberships`
  }

  public static riderLocation = class {
    public static indexForRider = `${Paths.riderLocationBaseUrl}/:riderId`
    public static removeById = `${Paths.riderLocationBaseUrl}/doRemoveOne/:id`
  }

  public static servicePricing = class {
    public static getByServiceIdOrgId = `${Paths.servicePricingBaseUrl}/retrieve`
  }
  public static servicePaymentMethods = class {
    public static create = `${Paths.servicePaymentMethodsBaseUrl}`
    public static getManyByServiceId = `${Paths.servicePaymentMethodsBaseUrl}`
    public static updateMany = `${Paths.servicePaymentMethodsBaseUrl}/update`
  }
  public static organizationTeamMember = class {
    public static base = Paths.organizationTeamMemberBaseUrl
    public static search = `${Paths.organizationTeamMemberBaseUrl}/search`
    public static inviteOne = `${Paths.organizationTeamMemberBaseUrl}/doInviteOne`
    public static createOne = `${Paths.organizationTeamMemberBaseUrl}`
    public static createFromUser = `${Paths.organizationTeamMemberBaseUrl}/user`
    public static updateOne = `${Paths.organizationTeamMemberBaseUrl}/doUpdateOne`
    public static archieve = `${Paths.organizationTeamMemberBaseUrl}/doArchive`
    public static activate = `${Paths.organizationTeamMemberBaseUrl}/doActivate/:userId/:organizationId`
  }

  public static stationUser = class {
    public static base = Paths.stationUserBaseUrl
    public static archieve = `${Paths.stationUserBaseUrl}/doArchive`
    public static search = `${Paths.stationUserBaseUrl}/search`
    public static update = `${Paths.stationUserBaseUrl}`
    public static createStationUser = `${Paths.stationUserBaseUrl}`
    public static getZone = `${Paths.stationUserBaseUrl}/zones`
    public static createOrUpdateZone = `${Paths.stationUserBaseUrl}/zones`
    public static getByUserId = `${Paths.stationUserBaseUrl}/doGetByUserId`
  }

  public static importTemplate = class {
    public static base = Paths.importTemplateBaseUrl
    public static byId = `${Paths.importTemplateBaseUrl}/:id`
    public static create = `${Paths.importTemplateBaseUrl}`
    public static update = `${Paths.importTemplateBaseUrl}`
    public static delete = `${Paths.importTemplateBaseUrl}/:id`
  }

  public static stationUserTrips = class {
    public static fetchStationUserTrips = `${Paths.stationUserBaseUrl}/trips`
  }

  public static driver = class {
    public static index = Paths.driverBaseUrl
    public static search = `${Paths.driverBaseUrl}/search`
    public static sessionHistory = `${Paths.driverBaseUrl}/sessionHistory`
    public static sessionHistoryV2 = `${Paths.driverV2BaseUrl}/sessionHistory`
    public static createSession = `${Paths.driverBaseUrl}/createSession`
    public static archive = `${Paths.driverBaseUrl}/doArchiveOne/:id`
    public static unarchive = `${Paths.driverBaseUrl}/doUnarchiveOne/:id`
    public static getManyByProvidersIds = `${Paths.driverBaseUrl}/doGetManyByProvidersIds`
    public static getOneById = `${Paths.driverBaseUrl}/doGetOneById`
    public static savePersonalInfo = `${Paths.driverBaseUrl}/doSavePersonalInfo`
    public static updatePersonalInfo = `${Paths.driverBaseUrl}/editPersonalInfo`
    public static saveProducts = `${Paths.driverBaseUrl}/doSaveProducts`
    public static removeProduct = `${Paths.driverBaseUrl}/:id/products/:productId`
    public static accumulatedHoursSummary = `${Paths.driverBaseUrl}/accumulatedHoursSummary`
    public static editSession = `${Paths.driverBaseUrl}/editSession`
    public static deleteSession = `${Paths.driverBaseUrl}/deleteSession`
    public static getSchedule = `${Paths.driverBaseUrl}/schedules`
    public static saveHomeAddress = `${Paths.driverBaseUrl}/homeAddress/doSave`
    public static updateHomeAddress = `${Paths.driverBaseUrl}/homeAddress/doUpdate`
    public static deleteHomeAddress = `${Paths.driverBaseUrl}/homeAddress/doRemoveOne`
    public static getHomeAddress = `${Paths.driverBaseUrl}/homeAddress/doGetAllById`
    public static getOperatorLocation = `${Paths.driverBaseUrl}/last_location/:operatorId`
    public static sendPushNotificationToDriver = `${Paths.tripsBaseUrl}/fcm-driver-schedule-update/send`
  }

  public static authentication = class {
    public static doLoginByCredentials = `${Paths.authBaseUrl}/doLoginByCredentials`
    public static refreshToken = `${Paths.authBaseUrl}/doRefreshToken`
    public static resendInviteEmail = `${Paths.apiV1BaseUrl}/resendInviteEmail`
    public static doSendPasswordRecoveryEmail = `${Paths.authBaseUrl}/doSendPasswordRecoveryEmail`
    public static checkPasswordRecoveryToken = `${Paths.authBaseUrl}/doCheckPasswordRecoveryToken`
    public static registerUser = Paths.registrationsRoot
  }

  public static serviceMembership = class {
    public static getManyByRiderIdAndOrgId = `${Paths.serviceMembershipBaseUrl}/doGetManyByRiderIdAndOrgId`
    public static getNewRequests = `${Paths.serviceMembershipBaseUrl}/doGetNewMembershipsByOrganizations`
    public static getProcessedRequests = `${Paths.serviceMembershipBaseUrl}/doGetProcessedMembershipsByOrganizations`
  }

  public static trips = class {
    public static base = Paths.tripsBaseUrl
    public static web = `${Paths.tripsBaseUrl}/web`
    public static recent = `${Paths.tripsBaseUrl}/recent`
    public static import = `${Paths.tripsBaseUrl}/import`
    public static importJson = `${Paths.tripsBaseUrl}/importJson`
    public static organizationTripHistory = `${Paths.tripsBaseUrl}/organizationTripHistory`
    public static updateStatus = `${Paths.tripsBaseUrl}/:id/doUpdateStatus`
    public static addStop = `${Paths.tripsBaseUrl}/:id/destinations`
    public static assignOperator = `${Paths.tripsBaseUrl}/:id/assignOperator`
    public static assignMultipleOperator = `${Paths.tripsBaseUrl}/multipleTripAssignOperator`
    public static cancelMultipleOperator = `${Paths.tripsBaseUrl}/multipleTripUpdateStatus`
    public static detail = `${Paths.tripsBaseUrl}/:id`
    public static editDetail = `${Paths.tripsBaseUrl}/edit/:id`
    public static getLastActiveTrips = `${Paths.tripsBaseUrl}`
    public static scheduled = `${Paths.tripsBaseUrl}/scheduled`
    public static assignedDispatchTrip = `${Paths.tripsBaseUrl}/assignedDispatchTrip`
    public static getLastActiveTripsByOrganizationAndStage = `${Paths.tripsBaseUrl}/doGetActiveByOrganizationIdAndStage`
    public static getManyStatusesByTripId = `${Paths.tripsBaseUrl}/doGetManyStatusesByTripId`
    public static waypointIndex = `${Paths.waypointServiceBaseUrl}`
    public static zoneTrips = `${Paths.tripsBaseUrl}/activeByZone`
    public static zoneIndex = `${Paths.zoneServiceBaseUrl}`
    public static zoneAll = `${Paths.zoneServiceBaseUrl}/getAllZones`
    public static zoneDetail = `${Paths.zoneServiceBaseUrl}/:id`
    public static getByLocations = `${Paths.zoneServiceBaseUrl}/doGetByLocation`
    public static recurTrip = `${Paths.tripsBaseUrl}/recur`
    public static generateRecurringTrips = `${Paths.tripsBaseUrl}/generateRecurringTrips`
    public static getDailyTripLog = `${Paths.tripsBaseUrl}/dailyTripLog/list`
    public static getTripLogPerServiceAndDateRange = `${Paths.tripsBaseUrl}/getTripLogPerServiceAndDateRange/list`
    public static getManyTripsPerOperator = `${Paths.tripsBaseUrl}/operator/doGetManyTripsPerOperator`
    public static getManyTripsPerOperatorV2 = `${Paths.tripsV2BaseUrl}/operator/doGetManyTripsPerOperator`
    public static getOperatorMetrics = `${Paths.tripsBaseUrl}/operators/metrics`
    public static getDriverManifests = `${Paths.tripsBaseUrl}/operators/driverManifest`
    public static countTripStatus = `${Paths.tripsBaseUrl}/tripStatuses/count`
    public static totalTripsPerService = `${Paths.tripsBaseUrl}/totalTripsPerService/:orgId`
    public static getTempVehicleByServiceCount = `${Paths.tripsBaseUrl}/temporary_vehicles/services`
    public static summary = `${Paths.tripsBaseUrl}/summary`
    public static sendPushNotification = `${Paths.tripsBaseUrl}/fcm-trip-update/send`
    public static driveTimes = `${Paths.tripsBaseUrl}/operators/driveTimes`
    //Weather
    public static weatherUpdates = `${Paths.tripsBaseUrl}/weather`
    public static getScheduledRequestedTrips = `${Paths.tripsBaseUrl}/scheduledRequestedTrips`
    public static updatePassengerDetails = `${Paths.tripsBaseUrl}/passengerDetails/doUpdate`
  }

  public static groupRides = class {
    public static assignOperator = `${Paths.groupRidesBaseUrl}/:id/assignOperator`
    public static unAssignOperator = `${Paths.groupRidesBaseUrl}/:id/unAssignOperator`

    public static groupRequestedScheduledTrips = `${Paths.tripsBaseUrl}/scheduled/group_rides`
    public static manual = `${Paths.tripsBaseUrl}/group_rides/manual`
    public static unGroupRequestedScheduledTrips = `${Paths.tripsBaseUrl}/ungroup/services`
  }

  public static user = class {
    public static changePasswordByRecoveryToken = `${Paths.userBaseUrl}/doChangePasswordByRecoveryToken`
    public static resendInvitation = `${Paths.userBaseUrl}/resendInvitation`
    public static baseWithId = `${Paths.userBaseUrl}/:id`
  }

  public static vehicles = class {
    public static base = Paths.vehicleBaseUrl
    public static list = `${Paths.vehicleBaseUrl}/list`
    public static updateProvidersAndProviderProducts = `${
      Paths.vehicleBaseUrl
    }/doUpdateVehicleProvidersAndProviderProducts`
    public static updateProviderProducts = `${Paths.vehicleBaseUrl}/doUpdateVehicleProviderProducts`
    public static changeActiveStatus = `${Paths.vehicleBaseUrl}/doChangeActiveStatus`
    public static updateProviders = `${Paths.vehicleBaseUrl}/doUpdateProviders`
    public static updateCapacity = `${Paths.vehicleBaseUrl}/doUpdateCapacity`
    public static remove = `${Paths.vehicleBaseUrl}/doRemove/:id`
    public static getCreationOptions = `${Paths.vehicleBaseUrl}/doGetCreationOptions`
    public static updateAccommodations = `${Paths.vehicleBaseUrl}/doUpdateAccommodations`
    public static unassignOperator = `${Paths.vehicleBaseUrl}/removeOperator/:id/:operatorId`
    public static getVehicleByOperatorIds = `${Paths.vehicleBaseUrl}/doGetByOperatorIds`
    public static saveVehicleDepotAddress = `${Paths.vehicleBaseUrl}/depotAddress/doSave/:vehicleId`
    public static updateVehicleDepotAddress = `${Paths.vehicleBaseUrl}/depotAddress/doUpdate`
    public static deleteVehicleDepotAddress = `${Paths.vehicleBaseUrl}/depotAddress/doRemoveOne/:id`
    public static getVehicleDepotAddress = `${Paths.vehicleBaseUrl}/depotAddress/doGetAllById/:vehicleId`
  }

  public static vehicleAccommodation = class {
    public static getAll = Paths.vehicleAccommodationBaseUrl
    public static create = Paths.vehicleAccommodationBaseUrl
    public static remove = `${Paths.vehicleAccommodationBaseUrl}/:id`
  }

  public static vehicleType = class {
    public static create = Paths.vehicleTypeBaseUrl
    public static remove = `${Paths.vehicleTypeBaseUrl}/:id`
  }

  public static vehicleColor = class {
    public static create = Paths.vehicleColorBaseUrl
    public static remove = `${Paths.vehicleColorBaseUrl}/:id`
  }

  public static vehicleMakes = class {
    public static create = Paths.vehicleMakeBaseUrl
    public static remove = `${Paths.vehicleMakeBaseUrl}/:id`
  }

  public static vehicleModel = class {
    public static create = Paths.vehicleModelBaseUrl
    public static remove = `${Paths.vehicleModelBaseUrl}/:id`
  }

  public static ping = class {
    public static getAvailableProducts = `${Paths.pingBaseUrl}/doGetAvailableProducts`
  }

  public static dispatch = class {
    public static getNearbyETAsByProductsIds = `${Paths.dispatchBaseUrl}/doGetNearbyETAsByProductsIds`
    public static getNearbyDrivers = `${Paths.dispatchBaseUrl}/doGetNearbyDrivers`
    public static tripDriverLocation = `${Paths.dispatchBaseUrl}/trips/:tripId/driverLocation`
    public static getProductOperators = `${Paths.pingBaseUrl}/getProductOperators`
    public static getOrgOperators = `${Paths.pingBaseUrl}/getOrgOperators/:orgId`
  }

  public static geolocation = class {
    public static getDirections = `${Paths.geolocationServiceBaseUrl}/locations/doGetDirections`
  }

  public static serviceDaysHours = class {
    public static baseWithId = `${Paths.serviceDaysHoursBaseUrl}/:id`
    public static baseWithServiceId = `${Paths.serviceDaysHoursBaseUrl}/:serviceId`
  }

  public static service = class {
    public static getServicesByOrdIdAndLocations = `${Paths.serviceBaseUrl}/getServicesByOrgIdAndLocations`
  }

  public static subscriptions = class {
    public static listPlans = `${Paths.subscriptionBaseUrl}/plans`
    public static getOrgSubscription = `${Paths.subscriptionBaseUrl}/:id`
    public static createOrgSubscription = `${Paths.subscriptionBaseUrl}/create`
    public static updateOrgSubscription = `${Paths.subscriptionBaseUrl}/update`
  }

  public static teamMemberPermission = class {
    public static getById = `${Paths.teamMemberPermissionBaseUrl}/:id`
    public static getByUserId = `${Paths.teamMemberPermissionBaseUrl}/by-user/:userId`
    public static create = `${Paths.teamMemberPermissionBaseUrl}`
    public static update = `${Paths.teamMemberPermissionBaseUrl}`
  }

  public static importProcess = class {
    public static riderImport = `${Paths.importBaseUrl}/riders`
    public static riderImportMemberships = `${Paths.importBaseUrl}/doUpdateRiderMemberships`
    public static riderImportExternalId = `${Paths.importBaseUrl}/doUpdateRiderExternalId`
  }
}



// WEBPACK FOOTER //
// ./src/utils/paths.ts